const readFile = (file: File) => {
    return new Promise((resolve, reject) => {
        // Create file reader
        const reader = new FileReader();

        // Register event listeners
        reader.addEventListener("loadend", (e) => resolve(e.target.result));
        reader.addEventListener("error", reject);

        // Read file
        reader.readAsArrayBuffer(file);
    });
};

export const getAsByteArray = async (file: File) => {
    const readedFile = (await readFile(file)) as ArrayBuffer;
    return new Uint8Array(readedFile);
};
